/** @jsx jsx */
import PropTypes from 'prop-types'
import { Box, Container, Grid, Heading, jsx } from 'theme-ui'
import Quote from '~/components/Generic/Quote'

const QuoteSection = ({ quotes, title, bgOverride }) => {
  return (
    <Box
      bg={bgOverride || 'backgroundMedium'}
      pt={[6, 7, null, 9]}
      pb={[7, 8, null, 10]}
    >
      <Container>
        {title && (
          <Heading
            as="h2"
            mb={[5, 6]}
            variant="title2"
            sx={{ textAlign: 'center' }}
          >
            {title}
          </Heading>
        )}
        <Grid columns={[1, 12]}>
          <Grid
            columns={[1, null, 3]}
            sx={{ gridColumn: [null, '2 / 12', '1 / -1'], rowGap: 6 }}
          >
            {quotes.map((quote, index) => {
              return <Quote key={index} quote={quote} />
            })}
          </Grid>
        </Grid>
      </Container>
    </Box>
  )
}

QuoteSection.propTypes = {
  quotes: PropTypes.arrayOf(PropTypes.shape({})),
}

export default QuoteSection
